import {
  FormControl,
  FormHelperText,
  InputLabel,
  createStyles,
  makeStyles
} from '@material-ui/core';
import HelperUtils from '@shared/utils/HelperUtils';
import React from 'react';
import {useTranslation} from 'react-i18next';
import NumberFormat, {NumberFormatProps} from 'react-number-format';
import CustomInputField from '@components/system/FormInput/StyledOutlinedInput';
import {INPUT_BORDER_COLOR, INPUT_LABEL_COLOR} from 'src/style/variable';
interface ICurrencyInputFieldProps extends Omit<NumberFormatProps, 'error'> {
  label?: string;
  error?: Record<string, any>;
}

const useStyles = makeStyles(() => {
  return createStyles({
    formControl: {
      paddingBottom: 0,
      marginBottom: 0,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: INPUT_BORDER_COLOR
      },
      '& input': {
        paddingBlock: "0.8rem"
      }
    }
  });
});

const CurrencyInputField = (props: ICurrencyInputFieldProps): JSX.Element => {
  const {t} = useTranslation();
  const {label, error, disabled, ...rest} = props;
  const classes = useStyles();
  return (
    <FormControl
      error={!!error}
      fullWidth={true}
      variant="standard"
      className={classes.formControl}
      disabled={disabled}>
      {label && (
        <InputLabel
          style={{
            position: 'static',
            transform: 'none',
            marginBottom: '0.5rem',
            fontSize: '1.1rem',
            color: INPUT_LABEL_COLOR
            // .MuiFormLabel-root.Mui-error to override the color
          }}
          shrink>
          {label}
        </InputLabel>
      )}
      <NumberFormat
        customInput={CustomInputField}
        thousandSeparator={true}
        prefix={'$'}
        placeholder={HelperUtils.formatCurrencyAmount(0, true)}
        decimalScale={2}
        fixedDecimalScale={true}
        {...rest}
        onChange={e => {
          if (rest.onChange) {
            rest.onChange(
              HelperUtils.formatCurrencyValueToFloat(e.target.value)
            );
          }
        }}
      />
      {error && <FormHelperText>{t(error.message)}</FormHelperText>}
    </FormControl>
  );
};

export default CurrencyInputField;
